import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { fieldsType } from "@/utils/types/field";
import fieldsDictionary from "@/components/fields/fieldsDictionary";
import { FieldViewType } from "@/components/fields/viewType";
import AddressFieldDetail from "@/components/fields/address/detail";
import AddressFieldEdit from "@/components/fields/address/edit";
import AddressFieldList from "@/components/fields/address/list";
import AddressFieldDetailFR from "@/components/fields/address/detail-fr_FR";
import AddressFieldDetailEN from "@/components/fields/address/detail-en_us";
import AddressFieldEditFR from "@/components/fields/address/edit-fr_FR";
import AddressFieldEditEN from "@/components/fields/address/edit-en_us";
/** <b>Composant qui contient l'affichage d'un champ de type address en: </b>
 * <li>Liste</li>
 * <li>Détails</li>
 * <li>Édition</li>
 */
export function Address() {
    return _jsx(_Fragment, { children: "Address" });
}
var field = fieldsType.address;
fieldsDictionary.registerField(FieldViewType.DETAIL, field, AddressFieldDetail);
fieldsDictionary.registerField(FieldViewType.DETAIL, field, AddressFieldDetailFR);
fieldsDictionary.registerField(FieldViewType.DETAIL, field, AddressFieldDetailEN);
fieldsDictionary.registerField(FieldViewType.EDIT, field, AddressFieldEdit);
fieldsDictionary.registerField(FieldViewType.EDIT, field, AddressFieldEditFR);
fieldsDictionary.registerField(FieldViewType.EDIT, field, AddressFieldEditEN);
fieldsDictionary.registerField(FieldViewType.LIST, field, AddressFieldList);
